import { render } from "./ToolSubmissionDetailsSettings.vue?vue&type=template&id=079e2a30"
import script from "./ToolSubmissionDetailsSettings.vue?vue&type=script&lang=js"
export * from "./ToolSubmissionDetailsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__